import { type ReactNode } from 'react'
import { Link, usePage } from '@inertiajs/react'

interface Props {
  children: ReactNode
}

const NAV_LINKS = [
  { label: 'Home', href: '/' },
  { label: 'Apps', href: '/apps' },
] as const

export default function AppShell({ children }: Props) {
  const { url } = usePage()

  function isActive(href: string) {
    if (href === '/') return url === '/'
    return url.startsWith(href)
  }

  return (
    <div className="min-h-screen bg-white text-gray-900">
      <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-16">
          <Link href="/apps" className="flex items-center gap-2.5 shrink-0">
            <div className="w-8 h-8 rounded-lg bg-brand/10 border border-brand/20 flex items-center justify-center">
              <svg className="w-4.5 h-4.5 text-brand" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 3.104v5.714a2.25 2.25 0 0 1-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 0 1 4.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0 1 12 15a9.065 9.065 0 0 0-6.23-.693L5 14.5m14.8.8 1.402 1.402c1 1 .03 2.711-1.379 2.711H4.178c-1.408 0-2.38-1.71-1.379-2.711L5 14.5" />
              </svg>
            </div>
            <span className="font-semibold text-sm text-gray-900">Optimal AI Labs</span>
          </Link>

          <nav className="flex self-stretch">
            {NAV_LINKS.map(({ label, href }) => {
              const active = isActive(href)
              return (
                <Link
                  key={href}
                  href={href}
                  className={[
                    'flex items-center px-4 text-sm transition-colors border-b-2',
                    active
                      ? 'text-gray-900 font-medium border-brand'
                      : 'text-gray-500 hover:text-gray-900 border-transparent',
                  ].join(' ')}
                >
                  {label}
                </Link>
              )
            })}
          </nav>

        </div>
      </header>

      <main>{children}</main>
    </div>
  )
}
